import React, { useContext, useEffect, useState } from 'react';
import { Box, Button, MenuItem, TextField, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { Context as GalleryContext } from '../../context/GalleryContext';

const EditGallery = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const gallery = location.state?.gallery;
    const galleryImages = Array.isArray(gallery?.images) ? gallery.images : [];

    const [name, setName] = useState(gallery?.name || '');
    const [mainImage, setMainImage] = useState(null);
    const [image, setImage] = useState(null);
    const [imageIndex, setImageIndex] = useState(0);

    const {
        state: { UpdateGalleryStatus },
        updateGallery,
        clearUpdateGalleryStatus,
    } = useContext(GalleryContext);

    useEffect(() => {
        if (!gallery) {
            navigate('/gallery', { replace: true });
        }
    }, [gallery, navigate]);

    useEffect(() => {
        if (UpdateGalleryStatus === 200) {
            clearUpdateGalleryStatus();
            navigate('/gallery');
        } else if (UpdateGalleryStatus >= 400) {
            clearUpdateGalleryStatus();
        }
    }, [UpdateGalleryStatus, clearUpdateGalleryStatus, navigate]);

    const handleSubmit = (event) => {
        event.preventDefault();
        updateGallery({
            galleryId: gallery?._id,
            name,
            mainImage,
            image,
            imageIndex,
        });
    };

    if (!gallery) return null;

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ mx: 'auto', p: 2 }}>
            <Typography variant="h4" gutterBottom>Update Gallery</Typography>

            <Typography variant="subtitle1" gutterBottom>Name</Typography>
            <TextField
                fullWidth
                required
                value={name}
                onChange={(event) => setName(event.target.value)}
            />

            <Box mt={2}>
                <Typography variant="subtitle1" gutterBottom>Main image</Typography>
                {gallery.mainImage && (
                    <Box component="img" src={gallery.mainImage} alt={gallery.name} sx={{ width: 270, height: 170, objectFit: 'cover', mb: 1 }} />
                )}
                <input accept="image/*" type="file" onChange={(event) => setMainImage(event.target.files[0] || null)} />
            </Box>

            <Box mt={2}>
                <Typography variant="subtitle1" gutterBottom>Replace a gallery image</Typography>
                {galleryImages.length > 0 && (
                    <TextField
                        select
                        fullWidth
                        label="Image to replace"
                        value={imageIndex}
                        onChange={(event) => setImageIndex(Number(event.target.value))}
                        sx={{ mb: 2 }}
                    >
                        {galleryImages.map((galleryImage, index) => (
                            <MenuItem key={index} value={index}>Image {index + 1}</MenuItem>
                        ))}
                    </TextField>
                )}
                <input accept="image/*" type="file" onChange={(event) => setImage(event.target.files[0] || null)} />
            </Box>

            {image && galleryImages[imageIndex] && (
                <Typography variant="body2" color="text.secondary" mt={1}>
                    Image {imageIndex + 1} will be replaced.
                </Typography>
            )}

            <Box mt={3}>
                <Button type="submit" variant="contained" color="primary" fullWidth>
                    Update Gallery
                </Button>
            </Box>
        </Box>
    );
};

export default EditGallery;
